import { default as CompaniesList } from './CompaniesList';

export default CompaniesList;
